import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=78de6724&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=ts"
export * from "./CatalogPage.vue?vue&type=script&lang=ts"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=78de6724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78de6724",
  null
  
)

export default component.exports